module.exports = __webpack_public_path__ + "fonts/dropify.86cb1ab0.ttf";